<template>
  <div class="c-app">
    <TheSidebar/>
    <CWrapper>
      <TheHeader v-if="$store.state.showHeader"/>
      <div class="c-body">
        <main class="c-main" style="background-color: white;">
          <CContainer fluid class="c-contents">
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
<!--        <TheFooter/>-->
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
  data:()=>{
    return {
      showHeader:true
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.c-main,.c-contents {
  padding:0px;
}
</style>
